import { lazy } from 'solid-js'
import { messages } from '../../pages/payouts-onboarding-page/payouts-onboarding-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/payouts-onboarding-page/payouts-onboarding-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    noIndex: true,
    path: '/payouts/onboarding',
    requiredMode: 'host',
    showFooter: false,
    showFullWidthHeader: true,
    showHeaderMenu: false,
    showSidebar: false,
    titleMessage: messages.titleMessage,
}
